var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 84,
    viewBox: "0 0 37 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36.4C15.9688 36.4 12.25 30.6572 12.25 16.8C12.25 30.6572 8.5575 36.4 0 36.4C8.5575 36.4 12.25 42.308 12.25 56C12.25 42.308 15.9688 36.4 24.5 36.4ZM35 12.6C29.5155 12.6 27.125 8.9096 27.125 0C27.125 8.9096 24.7502 12.6 19.25 12.6C24.7502 12.6 27.125 16.3996 27.125 25.2C27.125 16.3996 29.5155 12.6 35 12.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70.6C31.5155 70.6 29.125 66.9096 29.125 58C29.125 66.9096 26.7502 70.6 21.25 70.6C26.7502 70.6 29.125 74.3996 29.125 83.2C29.125 74.3996 31.5155 70.6 37 70.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartsRight);
export default __webpack_public_path__ + "static/media/startsRight.703838cfba87453ecd942f4c6f29e6c5.svg";
export { ForwardRef as ReactComponent };